/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/system',
    name: 'SYSTEM SETTINGS',
    view: 'System'
  },
  {
    path: '/notifications',
    name: 'NOTIFICATIONS',
    view: 'Notifications'
  },
  {
    path: '/tanks',
    name: 'TANKS',
    view: 'Tanks'
  },
  {
    path: '/sensors',
    name: 'SENSORS',
    view: 'Sensors'
  },
  {
    path: '/lineleakconfig',
    name: 'LINELEAKCONFIG',
    view: 'LineLeakConfig'
  },
  {
    path: '/tankstatus',
    name: 'TANKSTATUS',
    view: 'TankStatus'
  },
  {
    path: '/sensorstatus',
    name: 'SENSORSTATUS',
    view: 'SensorStatus'
  },
  {
    path: '/lineleakstatus',
    name: 'LINELEAKSTATUS',
    view: 'LineLeakStatus'
  },
  {
    path: '/tankgroupstatus',
    name: 'TANKGROUPSTATUS',
    view: 'TankGroupStatus'
  },
  {
    path: '/maintenance',
    name: 'MAINTENANCE',
    view: 'Maintenance'
  },
  {
    path: '/reports',
    name: 'REPORTS',
    view: 'Reports'
  },
  {
    path: '/passwordchange',
    name: 'PASSWORDCHANGE',
    view: 'PasswordChange'
  },
  {
    path: '/translate',
    name: 'Translate',
    view: 'Translate',
    meta: {
      anonymous: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
    meta: {
      anonymous: true
    }
  },
  {
    path: '/landingpage',
    name: 'LandingPage',
    view: 'LandingPage',
    meta: {
      anonymous: true
    }
  },
  {
    path: '/offlinemode',
    name: 'OfflineMode',
    view: 'OfflineMode'
  }
  /*
  ,
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'
  },
  {
    path: '/typography',
    view: 'Typography'
  },
  {
    path: '/icons',
    view: 'Icons'
  },
  {
    path: '/maps',
    view: 'Maps'
  },
  {
    path: '/notifications2',
    view: 'Notifications2'
  }
  */
]
